import React from 'react';
import { useSelector } from 'react-redux';

import _some from 'lodash/some';

import InfoIcon from 'cccisd-icons/info2';

import style from './style.css';

const ResponseRateBox = ({ label }) => {
    const role = label.toLowerCase();

    const backgroundColor = role === 'caregiver' ? '#e7a32a' : '#806fa6';

    const youthAndCaregiverSessions = useSelector(state => state.app.dashboard.youthAndCaregiverSessions);
    const selectedYouth = useSelector(state => state.app.dashboard.selectedYouth);
    const selectedYouthPlanDeploymentIds = selectedYouth
        ? selectedYouth.selectedAssignmentPlanList.map(assignmentPlan => assignmentPlan.assignmentPlanId)
        : [];

    const roleSessions = youthAndCaregiverSessions.filter(session => {
        // if a youth is selected instead of 'All':
        // only include the session if the session is for the selected youth
        // OR, if it is for a caregiver of the selected youth AND
        // the session of that caregiver is part of the parent deployment plans of the selected youth
        // (youths can share caregivers, so a caregiver that is part of the selected youth
        // can have session data not relevant for the selected youth)
        const appliesToSelectedUser =
            !selectedYouth ||
            (session.role === role && session.pawnId === selectedYouth.pawn.pawnId) ||
            (session.role === role &&
                selectedYouth.parentRoles.caregiverList.find(
                    caregiver =>
                        caregiver.pawn.pawnId === session.pawnId &&
                        _some(selectedYouthPlanDeploymentIds, id => id === session.planDeploymentId)
                ));

        return session.role === role && appliesToSelectedUser;
    });

    const totalSent = roleSessions.reduce((sum, session) => {
        return sum + session.sessionMessagesSent;
    }, 0);
    const totalCompleted = roleSessions.reduce((sum, session) => sum + session.sessionsCompleted, 0);
    const totalStarted = roleSessions.reduce((sum, session) => sum + session.sessionsStarted, 0);

    const completionPercentage = totalSent === 0 ? 0 : Math.round((totalCompleted / totalSent) * 100);
    const startedPercentage = totalSent === 0 ? 0 : Math.round((totalStarted / totalSent) * 100);

    return (
        <div className={style.response_rate_box} style={{ backgroundColor }}>
            <div className={style.response_rate_role}>{label}</div>
            <div className={style.dividing_line} />
            <div className={style.response_rate_stats}>
                <div className={style.response_rate_stat}>
                    <div className={style.response_rate_stat_label}>
                        Completion Rate <InfoIcon />
                    </div>
                    <div className={style.response_rate_percentage}>{completionPercentage}%</div>
                    <div className={style.response_rate_count}>
                        {totalCompleted}/{totalSent} sent
                    </div>
                </div>
                <div className={style.response_rate_divider} />
                <div className={style.response_rate_stat}>
                    <div className={style.response_rate_stat_label}>
                        Start Rate <InfoIcon />
                    </div>
                    <div className={style.response_rate_percentage}>{startedPercentage}%</div>
                    <div className={style.response_rate_count}>
                        {totalStarted}/{totalSent} sent
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResponseRateBox;
